<template>
  <div>
    <h1>Email tags</h1>
    <v-btn :to="{ name: 'emailTagAdd' }"> <v-icon>add</v-icon>Email tag </v-btn>
    <v-data-table
      :pagination.sync="pagination"
      :headers="headers"
      :items="emailTags"
      class="elevation-1"
      v-if="emailTags"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            <v-btn :to="{ name: 'emailTag', params: { id: props.item.id } }">{{
              props.item.id
            }}</v-btn>
          </td>
          <td>{{ props.item.name }}</td>
          <td>
            <div
              :style="`background:${props.item.colour};height:25px;width:75px;`"
            ></div>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "EmailTags",
  metaInfo() {
    return {
      title: "Email tags",
      titleTemplate: "%s - Email - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true,
      },
    };
  },
  data() {
    return {
      emailTags: null,
      pagination: {
        sortBy: "name",
        descending: true,
        page: 1,
        rowsPerPage: -1,
      },
      headers: [
        {
          text: "Id",
          value: "id",
        },
        {
          text: "Name",
          value: "name",
        },
        {
          text: "Colour",
          value: "colour",
        },
      ],
    };
  },
  methods: {
    async fetchEmailTags() {
      const response = await nbmlaw.get(`/cors/admin/email/emailTags`);
      // console.log(response.data)
      this.emailTags = response.data;
    },
  },
  created() {
    this.fetchEmailTags();
  },
};
</script>